/* Two-step Widerrufsbutton flow (page-cancel.hbs). No framework, no
   tracking beyond what the backend logs server-side for abuse triage
   (see services/cancel/app.py). Turnstile is loaded lazily, only once
   step 2 is actually shown, so a visitor who never proceeds past the
   intro never loads it. */
(function () {
    const root = document.querySelector('[data-widerruf-endpoint]');
    if (!root) return;

    const endpoint = root.getAttribute('data-widerruf-endpoint');
    const sitekey = root.getAttribute('data-widerruf-turnstile-sitekey');

    const stepIntro = root.querySelector('[data-widerruf-step="1"]');
    const stepForm = root.querySelector('[data-widerruf-step="2"]');
    const stepDone = root.querySelector('[data-widerruf-step="done"]');
    const startButton = root.querySelector('[data-widerruf-start]');
    const errorEl = root.querySelector('[data-widerruf-error]');
    const captchaEl = root.querySelector('[data-widerruf-captcha]');

    let turnstileWidgetId = null;
    let turnstileReady = false;

    function loadTurnstile(cb) {
        if (window.turnstile) { cb(); return; }
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        script.onload = cb;
        document.head.appendChild(script);
    }

    function showError(message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
    }

    function clearError() {
        errorEl.hidden = true;
        errorEl.textContent = '';
    }

    if (startButton) {
        startButton.addEventListener('click', function () {
            stepIntro.hidden = true;
            stepForm.hidden = false;

            if (sitekey && !turnstileReady) {
                loadTurnstile(function () {
                    turnstileWidgetId = window.turnstile.render(captchaEl, {sitekey: sitekey});
                    turnstileReady = true;
                });
            }
        });
    }

    if (stepForm) {
        stepForm.addEventListener('submit', function (event) {
            event.preventDefault();
            clearError();

            const formData = new FormData(stepForm);
            const payload = {
                name: (formData.get('name') || '').trim(),
                email: (formData.get('email') || '').trim(),
                tier: formData.get('tier') || '',
                contract_date: formData.get('contract_date') || '',
                note: (formData.get('note') || '').trim(),
                turnstile_token: window.turnstile && turnstileWidgetId !== null
                    ? window.turnstile.getResponse(turnstileWidgetId)
                    : ''
            };

            if (!payload.name || !payload.email || !payload.tier) {
                showError('Please fill in your name, email, and tier.');
                return;
            }
            if (sitekey && !payload.turnstile_token) {
                showError('Please complete the verification challenge.');
                return;
            }

            const confirmButton = stepForm.querySelector('[data-widerruf-confirm]');
            confirmButton.disabled = true;

            fetch(endpoint, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            }).then(function (res) {
                if (!res.ok) throw new Error('submit-failed');
                stepForm.hidden = true;
                stepDone.hidden = false;
            }).catch(function () {
                showError('Something went wrong sending this. Please try again, or email support@whywecanthavenicethings.info directly.');
                confirmButton.disabled = false;
                if (window.turnstile && turnstileWidgetId !== null) {
                    window.turnstile.reset(turnstileWidgetId);
                }
            });
        });
    }
})();
